import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import Banners from "./Banners";
import Promos from "./Promos";
import FeaturedProducts from "./FeaturedProducts";

// Banners state
import { getBanners } from "../../store/actions/banners";

class Home extends Component {
	static initialAction(store, props) {
		// console.log('Banners initialAction', store)
		let res = store !== null ? getBanners() : props.getBanners();
		return res;
	}

	componentDidMount() {
		// console.log('HOME BANNERS:', this.props.banners, !this.props.banners)
		if (!this.props.banners) {
			Home.initialAction(null, this.props);
		}
	}

	render() {
		return (
			<main>
				<Banners />
				<FeaturedProducts />
				<Promos />
			</main>
		);
	}
}

const mapStateToProps = state => {
	return {
		banners: state.banners.banners
	};
};

export default connect(mapStateToProps, { getBanners })(Home);



// WEBPACK FOOTER //
// ./src/components/home/Home.js